import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, BarChart3, Globe2, LayoutDashboard, Rocket } from 'lucide-react';
export function Slide08BrandBenefits() {
  const benefits = [{
    icon: TrendingDown,
    text: 'Up to 50% lower cost',
    color: '#4fd1c5'
  }, {
    icon: BarChart3,
    text: 'Full funnel measurement',
    color: '#ffd700'
  }, {
    icon: Globe2,
    text: 'National reach',
    color: '#60a5fa'
  }, {
    icon: LayoutDashboard,
    text: 'Real-time dashboard',
    color: '#f472b6'
  }, {
    icon: Rocket,
    text: 'Perfect for launches & trials',
    color: '#a78bfa'
  }];
  return <div className="flex flex-col h-full justify-center max-w-5xl mx-auto w-full" data-id="element-109">
      <motion.h2 className="text-5xl font-bold text-white mb-16 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} data-id="element-110">
        What Brands Get{' '}
        <span className="text-[#4fd1c5]" data-id="element-111">(Digital Sampling)</span>
      </motion.h2>

      <div className="space-y-6" data-id="element-112">
        {benefits.map((benefit, i) => <motion.div key={i} initial={{
        x: -50,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} transition={{
        delay: i * 0.15,
        type: 'spring'
      }} className="flex items-center gap-8 p-6 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-all hover:scale-[1.02]" data-id="element-113">
            <div className="p-4 rounded-xl" style={{
          backgroundColor: `${benefit.color}20`
        }} data-id="element-114">
              <benefit.icon className="w-8 h-8" style={{
            color: benefit.color
          }} data-id="element-115" />
            </div>
            <span className="text-2xl font-medium text-white" data-id="element-116">
              {benefit.text}
            </span>
          </motion.div>)}
      </div>
    </div>;
}